import ManagerHeader from "./ManagerHeader.js";
import ManagerDashboardNav from "./ManagerDashboardNav.js";
import ManagerProfileNav from "./ManagerProfileNav.js";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
    const location = useLocation();
    const isProfilePage = location.pathname.startsWith("/manager/profile");
    return (
        <>
            <ManagerDashboardNav />
            <ManagerHeader />
            {isProfilePage && <ManagerProfileNav />}
            <Outlet /> {/* ← profile navの横に来る */}
        </>
    );
}

export default Layout;